import React from "react";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import LanguageSwitcher from "../../components/LanguageSwitcher";
import ThemeToggle from "../../components/ThemeToggle";
import { appConfig } from "../../config/app.config";

export function HomeHeader() {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();
  const scrollToSection = (event: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    event.preventDefault();
    const target = document.getElementById(sectionId);
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
      window.history.replaceState(null, "", `#${sectionId}`);
      return;
    }
    navigate(`/#${sectionId}`);
  };

  return (
    <header className="sticky top-0 z-30 border-b border-border-subtle bg-bg-surface/95 backdrop-blur">
      <div className="mx-auto flex h-[76px] max-w-[1296px] items-center justify-between gap-3 px-5 sm:px-8 lg:px-0">
        <button type="button" onClick={() => { navigate("/"); }} className="flex min-w-0 items-center gap-3" aria-label={appConfig.name}>
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-action-primary text-white shadow-raised">
            {React.createElement(appConfig.icon.component, { className: "h-5 w-5" })}
          </span>
          <span className="hidden min-w-0 flex-col items-start sm:flex">
            <span className="truncate font-mono text-sm font-bold uppercase tracking-normal text-text-primary">{appConfig.name}</span>
            <span className="truncate font-mono text-[10px] font-semibold uppercase tracking-normal text-text-muted">DSH Desktop</span>
          </span>
        </button>

        <nav className="hidden items-center gap-7 text-sm font-medium text-text-secondary lg:flex" aria-label={t("home.primaryNavigation")}>
          <a href="#capabilities" onClick={(event) => scrollToSection(event, "capabilities")} className="transition-colors hover:text-text-primary">{t("home.navCapabilities")}</a>
          <a href="#services" onClick={(event) => scrollToSection(event, "services")} className="transition-colors hover:text-text-primary">{t("home.navServices")}</a>
          <a href="#workflow" onClick={(event) => scrollToSection(event, "workflow")} className="transition-colors hover:text-text-primary">{t("home.navWorkflow")}</a>
          <a href="#download" onClick={(event) => scrollToSection(event, "download")} className="transition-colors hover:text-text-primary">{t("home.navDownload")}</a>
        </nav>

        <div className="flex shrink-0 items-center gap-0.5 sm:gap-2">
          <ThemeToggle compact />
          <LanguageSwitcher compact />
          <button type="button" onClick={() => { navigate("/login"); }} className="hidden h-[38px] shrink-0 items-center whitespace-nowrap rounded-md px-4 text-sm font-semibold text-text-primary transition-colors hover:bg-bg-elevated md:flex">
            {t("home.signIn")}
          </button>
          <button type="button" onClick={() => { navigate("/register"); }} aria-label={t("home.signUp")} className="flex h-10 shrink-0 items-center gap-2 rounded-md bg-action-primary px-3 text-sm font-semibold text-action-primary-text shadow-raised transition-colors hover:bg-action-primary-hover sm:px-4">
            <span className="hidden sm:inline">{t("home.signUp")}</span>
            <ArrowRight className="h-4 w-4" />
          </button>
        </div>
      </div>
    </header>
  );
}
